"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocusignConfigOutSerializer = void 0;
exports.DocusignConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=docusignConfigOut.js.map